import {
  TOGGLE_DMX_UNIVERSE_STATUS,
  TOGGLE_DMX_UNIVERSE_STATUS_SUCCESSFUL,
  TOGGLE_DMX_UNIVERSE_STATUS_FAILED,
} from './actionTypes';

export const toggleDmxUniverseStatus = (universe) => {
  return {
    type: TOGGLE_DMX_UNIVERSE_STATUS,
    payload: { universe },
  };
};

export const toggleDmxUniverseStatusSuccessful = (message) => {
  return {
    type: TOGGLE_DMX_UNIVERSE_STATUS_SUCCESSFUL,
    payload: message,
  };
};

export const toggleDmxUniverseStatusFailed = (message) => {
  return {
    type: TOGGLE_DMX_UNIVERSE_STATUS_FAILED,
    payload: message,
  };
};
